import { SearchResultType } from '../../../../state/types';
import { reportThreadSearchSubmitted } from '../events';
import {
  SearchSubmittedQueryDetails,
  SearchSubmittedThreadFilter,
  ThreadSearchSubmittedResultType,
} from '../events/searchEvents.types';

import { reportGroupSearchSubmitted } from './reportGroupSearchSubmitted';
import { reportQuestionSearchSubmitted } from './reportQuestionSearchSubmitted';

type ReportSearchSubmitted = (
  searchResultType: SearchResultType,
  queryProps: SearchSubmittedQueryDetails,
  filters: SearchSubmittedThreadFilter
) => void;
export const reportSearchSubmitted: ReportSearchSubmitted = async (searchResultType, queryProps, filters) => {
  const { conversationId, logicalId, queryLength, wordCount, conversationStart } = queryProps;

  const searchSubmittedProps = {
    conversationId,
    conversationStart,
    logicalId,
    queryLength,
    wordCount,
  };

  if (searchResultType === SearchResultType.Group) {
    reportGroupSearchSubmitted(searchSubmittedProps);
  } else if (searchResultType === SearchResultType.GlobalNetworkQuestion) {
    reportQuestionSearchSubmitted(searchSubmittedProps);
  } else {
    const { groupTelemetryId, dateFilterStartTimestamp, dateFilterEndTimestamp } = filters;
    const threadSearchSubmittedProps = {
      ...searchSubmittedProps,
      resultType: searchResultType as ThreadSearchSubmittedResultType,
      filters: {
        groupTelemetryId,
        dateFilterStartTimestamp,
        dateFilterEndTimestamp,
      },
    };
    reportThreadSearchSubmitted(threadSearchSubmittedProps);
  }
};
